import { render, staticRenderFns } from "./residual.vue?vue&type=template&id=32ac360e"
import script from "./residual.vue?vue&type=script&lang=js"
export * from "./residual.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports